import './App.css';
import Header from './components/Header/Header';
import Meal from './components/Meal/Meal';

function App() {
  return (
    <div>
      <Header></Header>
      <Meal></Meal>
    </div>
  );
}

export default App;
